import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { RelatedLink } from "@webapp/links/models/links.models";
import { IRelatedItem } from "@webapp/links/models/related-items.models";
import { ButtonSelectComponent } from "@webapp/shared/components/button-select/button-select.component";
import { IButtonSelectOptions } from "@webapp/shared/components/button-select/button-select.models";

const relationshipOptions: IButtonSelectOptions[] = [
  {
    value: "relating",
    label: "relates_to",
  },
  {
    value: "blocked",
    label: "blocked_by",
  },
  {
    value: "blocking",
    label: "blocks",
  },
  {
    value: "supported",
    label: "supported_by",
  },
  {
    value: "supporting",
    label: "supports",
  },
  {
    value: "preceded",
    label: "continuation_of",
  },
  {
    value: "preceding",
    label: "precedes",
  },
];

@Component({
  selector: "relationship-options-button",
  templateUrl: "./relationship-options-button.component.html",
  styleUrls: ["./relationship-options-button.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelationshipOptionsButtonComponent implements OnInit {
  @Input() public relatedItem: IRelatedItem;
  @Input() public disabled: boolean;
  @Output() public readonly updateOption = new EventEmitter<RelatedLink>();

  @ViewChild(ButtonSelectComponent) public buttonSelect: ButtonSelectComponent;

  public relationshipOptions: IButtonSelectOptions[] = relationshipOptions;
  public selectedLink: string;

  public ngOnInit(): void {
    this.selectedLink = this.relationshipOptions.find((option) => this.relatedItem.linkType === option.value).label;
  }

  public onUpdateLinkOption(updatedValue: RelatedLink): void {
    this.selectedLink = this.relationshipOptions.find((option) => updatedValue === option.value).label;

    this.updateOption.emit(updatedValue);
  }
}
